// Public analytics IDs. Rebuild/deploy after changing this configuration.
export const analyticsConfig = {
  gaMeasurementId: "G-LV9W8SRJ63",
  clarityProjectId: "ydi2401dbb",
  // Enable only in a temporary test build to inspect its events in GA4 DebugView.
  debug: false,
};
